import {axiosInstance} from "@/plugins/axios";
import {MaterialDeclaration} from "@/modules/material_declaration/types";

export async function saveMaterialDeclaration(materialDeclaration: MaterialDeclaration) {
  const response = await axiosInstance.post(`material_declarations`, materialDeclaration);
  return response.data;
}

export async function saveMaterialDeclarations(materialDeclarations: MaterialDeclaration[]) {
  const response = await axiosInstance.post(`material_declarations/create_or_update_many`, {
    material_declarations: materialDeclarations
  });
  return response.data;
}
